const missionSrc = `${process.env.PUBLIC_URL}/img/mission.png`;

function CompanyIntroPage() {
  return (
    <section className="page company-about">
      <div className="company-about__grid">
        <div className="company-about__copy">
          <p className="company-about__eyebrow">ABOUT US</p>
          <h1 className="company-about__title">회사 소개</h1>
          <span className="company-about__rule" aria-hidden="true" />
          <div className="company-about__prose">
            <p>
              안녕하십니까?
              <br />
              글로벌기업문화를 선도하는 귀사와 인연을 맺게 되어 무한한 영광으로 생각합니다.
              <br />
              최고의 품질과 무재해, 고객만족을 위해 수고하시는 귀사의 노고에 조금이나마 도움이
              되도록 하겠습니다.
            </p>
            <p>
              당사 안전용품, 광고물(BI, CI, SIGN보드 등), 건설자재, 가설자재 등을 제작납품하는
              건설안전의 초석이 되고자 하는 회사이며,
            </p>
            <p>
              납기준수와 최고의 품질을 위해 저희 임직원은 최고의 “안전도우미”가 되도록
              노력하겠습니다.
              <br />
              믿고 맡겨 주시면 “안전도우미”로서의 일등 일꾼이 되겠습니다.
              <br />
              감사합니다.
            </p>
          </div>
        </div>
        <figure className="company-about__media">
          <img
            src={missionSrc}
            alt="안전모가 정리되어 있는 현장"
            className="company-about__img"
            width={480}
            height={720}
            loading="lazy"
          />
        </figure>
      </div>
    </section>
  );
}

export default CompanyIntroPage;
